import {
  GetVisitByIdTranscription,
  StartVisitTranscriptionResponseDto,
  VisitTranscriptionDto,
  VisitTranscriptionDtoStatusEnum,
  VisitTranscriptionSegmentDto,
  VisitTranscriptionSegmentDtoSpeakerEnum,
} from 'woofwoof-api';

export const VisitTranscriptionStatus = VisitTranscriptionDtoStatusEnum;
export type VisitTranscriptionStatusValue = VisitTranscriptionDtoStatusEnum;

export const VisitTranscriptionSpeaker =
  VisitTranscriptionSegmentDtoSpeakerEnum;
export type VisitTranscriptionSpeakerValue =
  VisitTranscriptionSegmentDtoSpeakerEnum;

export type VisitTranscriptionSegment = VisitTranscriptionSegmentDto;
export type VisitTranscription =
  | VisitTranscriptionDto
  | GetVisitByIdTranscription;
export type StartVisitTranscriptionResponse =
  StartVisitTranscriptionResponseDto;

export type VisitTranscriptionActivity =
  | 'idle'
  | 'starting'
  | 'recording'
  | 'recording-elsewhere'
  | 'synchronizing'
  | 'reviewing'
  | 'stopping';
